import React from 'react';
import { FeaturedBenefitBlockType, LayoutVariant } from '../../../../../../../types/featuredBenefitBlockType';
import { WithQnA } from '../WithQnA/WithQnA';
import { VerticalWithList } from '../VerticalWithList/VerticalWithList';
import { HorizontalWithMedia } from '../HorizontalWithMedia/HorizontalWithMedia';
import * as S from './FeaturedBenefitBlock.styles';

export type FeaturedBenefitBlockTypeProps = {
  block: FeaturedBenefitBlockType;
};

export const FeaturedBenefitBlock: React.FC<FeaturedBenefitBlockTypeProps> = ({ block }) => {
  const { layoutVariant } = block;

  switch (layoutVariant) {
    case LayoutVariant.HORIZONTAL:
      return (
        <S.FullWidthWrapper>
          <HorizontalWithMedia block={block} />
        </S.FullWidthWrapper>
      );

    case LayoutVariant.FAQ:
      return (
        <S.SmallContainer>
          <WithQnA block={block} />
        </S.SmallContainer>
      );

    case LayoutVariant.VERTICAL:
      return (
        <S.FullWidthWrapper>
          <VerticalWithList block={block} />
        </S.FullWidthWrapper>
      );

    default:
      return null;
  }
};
